<template>
  <span>
    <v-alert type="info" icon='info' dense :value="!!info" class="mb-4">{{ info }}</v-alert>
    <v-alert type="warning" icon='warning' dense :value="!!warning" class="mb-4">{{ warning }}</v-alert>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import Config from '@/config';
import Component from 'vue-class-component';
@Component({})
export default class Announcement extends Vue {
	info: string = Config.ANNOUNCEMENT_INFO;
	warning: string = Config.ANNOUNCEMENT_WARNING;
}
</script>
